import { createContext, useContext } from 'react';

export enum GeneralError {
  NONE = 'none',
  SAVE_FAILED = 'saveFailed',
  TEMPLATE_LOAD_FAILED = 'templateLoadFailed',
  CONVERSION_TABLE_LOAD_FAILED = 'conversionTableLoadFailed',
  EQUATIONS_LOAD_FAILED = 'equationLoadFailed',
  VALIDATION_FAILED = 'projectValidationFailed',
  EQUATION_UPGRADE_FAILED = 'equationUpgradeFailed',
  SCHEMA_MIGRATION_FAILED = 'schemaMigrationFailed',
}

export interface GenErrorContext {
  currentError: GeneralError;
  setError: (err: GeneralError) => void;
  clearError: () => void;
}

const noop = () => {};
export const GeneralErrorContext = createContext<GenErrorContext>({
  currentError: GeneralError.NONE,
  setError: noop,
  clearError: noop,
});

export const useGeneralError = () => {
  return useContext(GeneralErrorContext);
};
